import {CancelIcon} from "./Icon/Cancel.icon.tsx";
import {FC, useEffect, useRef} from "react";
import {AlertType} from "../model/Alert.ts";

interface AlertComponentProps {
    name: string,
    description: string,
    type: AlertType,
    onCancel: (created: number) => void
    created: number
}
export const AlertComponent: FC<AlertComponentProps> = ({name,  description, onCancel, type, created}) => {
    const mainColor = {
        [AlertType.SUCCESS]: "bg-green-100 border-green-400 text-green-400",
        [AlertType.ERROR]: "bg-red-100 border-red-400 text-red-400",
        [AlertType.INFO]: "bg-gray-100 border-gray-400 text-gray-400"
    }
    const progressColor = {
        [AlertType.SUCCESS]: "bg-green-300",
        [AlertType.ERROR]: "bg-red-300",
        [AlertType.INFO]: "bg-gray-300"
    }

    // Create a ref to the progress bar element
    const progressBarRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const timeoutId2 = setTimeout(() => {
            if (progressBarRef.current) {
                progressBarRef.current.classList.add('scale-x-0');
            }
        }, 100);

        const timeoutId = setTimeout(() => {
            onCancel(created);
        }, 3000);

        return () => {
            clearTimeout(timeoutId);
            clearTimeout(timeoutId2);
        };

    }, []);

    return <div className={`border ${mainColor[type]} px-4 py-3 rounded relative m-2`} role="alert">
        <strong className="font-bold">{name}</strong>
        <span className="block sm:inline px-2">{description}</span>
        <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer flex items-center justify-center" onClick={() => onCancel(created)}>
            <CancelIcon />
        </span>
        <div
            ref={progressBarRef}
            className={`h-1 ${progressColor[type]} absolute bottom-0 left-0 right-0 transform origin-left transition-transform ease-linear duration-[3000ms]`}
        ></div>
    </div>
}